/* 🤖 this file was generated by svg-to-ts*/
export const iconPrice16: {
  name: 'price_16';
  data: string;
} = {
  name: 'price_16',
  data: `<svg width="16" height="16" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" d="M2.414 7.934l5.657 5.657 5.317-5.317-.566-5.091-5.091-.566-5.317 5.317zM7.475.577l6.363.707a1 1 0 01.884.883l.707 6.364c.033.302-.073.603-.287.818l-6.364 6.363a.996.996 0 01-1.414 0L.293 8.64a.997.997 0 010-1.414L6.657.863a.99.99 0 01.818-.286zm-.818 5.942a1 1 0 00-1.414 1.414l2.828 2.83a.997.997 0 001.414 0 .999.999 0 000-1.415zm4.95-2.12a.999.999 0 10-1.415 1.414.999.999 0 101.414-1.414z"/></svg>`,
};
